import {
    IContentWrapperProps,
    IContentColumnProps,
} from './ContentWrapper.interface';
import '@/layouts/ContentWrapper/ContentWrapper.styles.css';
import { clsx } from 'clsx';

const ContentWrapper = ({ children, className }: IContentWrapperProps) => {
    return <div className={clsx('contentWrapper', className)}>{children}</div>;
};

const ContentColumn = ({
    children,
    layout,
    align,
    className,
}: IContentColumnProps) => {
    return (
        <div
            className={clsx(
                'contentColumn',
                layout === 'two-thirds' && 'contentColumn__layout--twoThirds',
                layout === 'half' && 'contentColumn__layout--half',
                align === 'right' && 'contentColumn__align--right',
                className,
            )}
        >
            {children}
        </div>
    );
};

export { ContentWrapper as default, ContentColumn };
